import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  button {
    display: block;
    color: var(--velotax-font-color);
    background-color: var(--velotax-background-color);
    font-weight: 500;
  }
`;
